export default __webpack_public_path__ + "static/media/ktel_logo.7b00962a.png";